import { version } from '../package.json';

export class Mainframe {
  public static readonly version = version;

  constructor() {
    console.info(`Mainframe v${Mainframe.version} constructed`);
  }
}
